// TODO re-enable test in features/home/components/HomeDateRangeSelector/inferDateRangeType.spec.ts when this file is removed

const VITE_STRIPE_PUBLIC_KEY = import.meta.env.VITE_STRIPE_PUBLIC_KEY

// eslint-disable-next-line no-undef
export const stripe = Stripe(VITE_STRIPE_PUBLIC_KEY)

/**
 * Create Payment Method
 * @param {object} paymentMethodData New Payment Method Data
 */
export const createPaymentMethod = async (paymentMethodData) =>
  stripe.createPaymentMethod({
    card: paymentMethodData,
    type: 'card',
  })
